// Company Balance Actions

// Get Company Balance
export const GET_COMPANY_BALANCE_REQUEST = 'GET_COMPANY_BALANCE_REQUEST';
export const GET_COMPANY_BALANCE_SUCCESS = 'GET_COMPANY_BALANCE_SUCCESS';
export const GET_COMPANY_BALANCE_FAILURE = 'GET_COMPANY_BALANCE_FAILURE';

// Get Company Balance Logs
export const GET_COMPANY_BALANCE_LOGS_REQUEST = 'GET_COMPANY_BALANCE_LOGS_REQUEST';
export const GET_COMPANY_BALANCE_LOGS_SUCCESS = 'GET_COMPANY_BALANCE_LOGS_SUCCESS';
export const GET_COMPANY_BALANCE_LOGS_FAILURE = 'GET_COMPANY_BALANCE_LOGS_FAILURE';

// Set Filters
export const SET_COMPANY_BALANCE_FILTERS = 'SET_COMPANY_BALANCE_FILTERS';
export const CLEAR_COMPANY_BALANCE_FILTERS = 'CLEAR_COMPANY_BALANCE_FILTERS';

// Clear Errors
export const CLEAR_COMPANY_BALANCE_ERRORS = 'CLEAR_COMPANY_BALANCE_ERRORS';

// Loading States
export const SET_COMPANY_BALANCE_LOADING = 'SET_COMPANY_BALANCE_LOADING';
export const SET_COMPANY_BALANCE_LOGS_LOADING = 'SET_COMPANY_BALANCE_LOGS_LOADING';
